import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/bold-editorial/components/BoldEditorialViewer.tsx");
